import { Dispatch } from 'redux';
import { axiosV2 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';
import types from 'redux/actions/actionTypes';
import { ApiQueryParams } from 'types/ApiQueryParams';

import { IncentivesMarketBeneficiary } from '../types';

export const getBeneficiaries =
  (societyId: string, params?: ApiQueryParams, source = 'list') =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/beneficiaries', {
        params: { societyId, ...params, source },
      });
      const decodedData: any = await decryptResponse(data);
      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const getBeneficiary =
  (beneficiaryId: string, params?: Record<string, unknown>) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/beneficiaries/${beneficiaryId}`, {
        params,
      });
      const decodedData = await decryptResponse(data);
      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const updateBeneficiary =
  ({
    beneficiaryId,
    updateBeneficiaryData,
  }: {
    beneficiaryId: string;
    updateBeneficiaryData: Partial<IncentivesMarketBeneficiary> & {
      userId?: string;
      society?: string;
    };
  }) =>
  async (dispatch: Dispatch) => {
    try {
      const body = { _id: beneficiaryId, ...updateBeneficiaryData };
      const { data } = await axiosV2.put('/beneficiaries', body);
      const decodedData = await decryptResponse(data);
      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const getBeneficiaryIncentivesMarketContext =
  ({
    beneficiaryId,
    societyId,
    stockPlanId,
    excludeOfferId,
    incentiveOfferId,
  }: {
    beneficiaryId: string;
    societyId: string;
    stockPlanId?: string;
    excludeOfferId?: string;
    incentiveOfferId?: string;
  }) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(
        `/beneficiaries/${beneficiaryId}/incentives-market-context`,
        {
          params: {
            societyId,
            ...(stockPlanId ? { stockPlanId } : {}),
            ...(excludeOfferId ? { excludeOfferId } : {}),
            ...(incentiveOfferId ? { incentiveOfferId } : {}),
          },
        }
      );
      const decodedData = await decryptResponse(data);
      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };

export const toggleBeneficiaryIncentivesMarketAccess =
  ({
    beneficiaryIds,
    enabled,
  }: {
    beneficiaryIds: string[];
    enabled: boolean;
  }) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.put(
        '/beneficiaries/incentivesMarket/toggle',
        { beneficiaryIds, enabled }
      );
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.TOGGLE_BENEFICIARY_INCENTIVES_MARKET_ACCESS,
        beneficiaryIds,
        enabled,
      });

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
